export default __webpack_public_path__ + "static/media/gallery_06.35a54f11.jpg";